module.exports = function() {
  return new Worker("/" + "svelte-transpiler.96490c9e.worker.js");
};